import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana5Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
  
  <rect width="1221" height="921" fill="url(#pattern0_1467_39122)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M694.453 414.305V520.018L624.728 499.775L660.715 396.312C689.954 398.561 694.453 406.808 694.453 414.305Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M694.448 641.475V520.018L678.704 515.52L613.477 625.731L671.956 657.219C688.151 659.019 693.699 647.473 694.448 641.475Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M568.493 598.742L613.477 625.733L678.704 515.522L624.723 499.777L568.493 598.742Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M595.486 391.818L660.713 396.316L624.725 499.779L566.246 481.786L595.486 391.818Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M514.509 567.252L568.49 598.741L624.72 499.776L566.24 481.783L514.509 567.252Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M451.53 533.514L514.507 567.252L566.239 481.783L496.514 459.291L451.53 533.514Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M525.751 382.817L498.76 459.29L566.236 481.782L595.476 391.814L525.751 382.817Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M442.534 376.071L525.754 382.818L498.764 459.291L413.294 432.301L442.534 376.071Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M377.31 490.779L451.533 533.514L496.517 459.29L413.297 432.3L377.31 490.779Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M327.828 461.54L377.311 490.78L413.298 432.3L442.537 376.07L379.56 371.572L327.828 461.54Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M307.578 360.328L379.553 371.574L327.821 461.542L269.342 425.555L307.578 360.328Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M210.869 342.333L307.584 360.327L269.348 425.554L184.917 373.596C182.914 372.364 181.792 370.054 182.215 367.741C186.818 342.544 203.003 340.188 210.869 342.333Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1467_39122" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1467_39122" transform="matrix(0.00308515 0 0 0.00409009 -6.17147 -0.899124)"/>
    </pattern>
    <image id="image0_1467_39122" width="4096" height="2304" href="/mz2.png"/>
    </defs>
    </svg>

  );
};